import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";



const AccountsReportForm = () => {
  const [formData, setFormData] = useState({
    accounts: [],
    includeClosed: false,
    tags: [],
    format: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked, multiple } = e.target;
    if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else if (multiple) {
      const options = Array.from(e.target.selectedOptions, option => option.value);
      setFormData(prevState => ({
        ...prevState,
        [name]: options
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
  };

  return (
    <Container className="mt-4" style={{ maxWidth: '600px',marginLeft:"0px" }}>
      <Form onSubmit={handleSubmit} className="p-4 border rounded">
        <fieldset>
          <legend>Parameters</legend>

          {/* Accounts Multi-Select Dropdown */}
          <Form.Group as={Row} controlId="accounts" className="mb-3">
            <Form.Label column sm="4" title="Please choose an account to limit the report to">
              Accounts
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="accounts"
                value={formData.accounts}
                onChange={handleChange}
                multiple
                className="form-select"
                size="10"
                title="Please choose an account to limit the report to"
              >
                <option value="">All</option>
                <option value="144545">2ingis s.a.</option>
                <option value="71159">ALL SAINTS DENTAL</option>
                <option value="137334">Andrew Lee (Diu Resh)</option>
                <option value="109766">Andrew Lee Dental (Roebuck Louise)</option>
                <option value="109767">Andrew Lee Dental (T Hyare)</option>
                <option value="7675">Aviva Cosmetic Dentistry Ltd.</option>
                <option value="105909">Bankton Dental Practice</option>
                <option value="132450">Beaumont Dental</option>
                <option value="113615">BELL GREEN DENTAL (DR. ALI)</option>
                <option value="71164">BELL GREEN DENTAL (DR.MOHAMMED FIAZ)</option>
                <option value="113613">BELL GREEN DENTAL (DR.TOSEEF HUSSAIN)</option>
                <option value="98142">Bhandal Dental (Mindi Dhanjal)</option>
                <option value="86521">Bhandal Dental Practice (Dr H Mudhar)</option>
                <option value="87386">Bhandal Dental practice (Dr Mandip)</option>
                <option value="86599">Bhandal Dental practice (M. Casha)</option>
                <option value="123309">Swissmeda(Synergy Dental Little Lever)</option>
                <option value="142735">Swissmeda(Synergy Dental Ormskirk)</option>
                <option value="118712">Swissmeda(Ten Dental)</option>
                <option value="144258">Swissmeda(The Linden Tree Dental Lounge)</option>
                <option value="124445">Swissmeda(The Savernake Dental Practice)</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Include Closed Checkbox */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="4">&nbsp;</Form.Label>
            <Col sm="8">
              <Form.Check
                type="checkbox"
                name="includeClosed"
                checked={formData.includeClosed}
                onChange={handleChange}
                label="Include Closed"
                style={{ marginLeft: 0 }}
              />
            </Col>
          </Form.Group>

          {/* Tags Multi-Select Dropdown */}
          <Form.Group as={Row} controlId="tags" className="mb-3">
            <Form.Label column sm="4" title="Select tags to filter report">
              Account Tags
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="tags"
                value={formData.tags}
                onChange={handleChange}
                multiple
                className="form-select"
                size="6"
                title="Select tags to filter report"
              >
                <option value="">No filter</option>
                <option value="a-practices">a-practices</option>
                <option value="bhandal">bhandal</option>
                <option value="coventry-dental">coventry-dental</option>
                <option value="dental-beauty">dental-beauty</option>
                <option value="murray-dental-">murray-dental-</option>
                <option value="swissmeda">swissmeda</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Format Selection */}
          <Form.Group as={Row} controlId="format" className="mb-3">
            <Form.Label column sm="4" title="Please choose a display format">
              Format <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="format"
                value={formData.format}
                onChange={handleChange}
                className="form-select"
                title="Please choose a display format"
                required
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Submit Button */}
          <Form.Group as={Row} className="mb-0">
            <Col sm={{ span: 8, offset: 4 }}>
               <Link to="/AddAccountTaxes">
              <Button
                type="submit"
                variant="primary"
                className="w-100"
                style={{
                  backgroundColor: '#004aad',
                  borderColor: '#004aad',
                  marginTop: '10px',
                }}
              >
                <span className="ico-search"></span> Run
              </Button>
              </Link>
            </Col>
          </Form.Group>
        </fieldset>
      </Form>
    </Container>
  );
};

export default AccountsReportForm;
